module.exports = __webpack_public_path__ + "img/booth7.395c7f10.png";